import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 6px auto;
  padding: 10px 14px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const NameArea = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
`;
export const IconsArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  gap: 10px;
`;
export const StudentName = styled.span`
  font-size: 15px;
  font-weight: 600;
`;
export const CardsArea = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 4px 16px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
export const ButtonsArea = styled.div`
  display: flex;
  margin: 24px 0 16px;
  justify-content: center;
  align-items: start;
`;
export const AreaText = styled.div`
  width: 98%;
  margin: auto;
`;

export const ExpandedContent = styled.div`
  width: 100%;
  margin-top: 12px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  overflow: hidden;
`;
